const ArrowRightBigIcon = () => {
  return (
    <svg
      width="30"
      height="22"
      viewBox="0 0 30 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6452 12.8333L16.0818 19.415L18.6668 22L29.6668 11L18.6668 0L16.0818 2.585L22.6452 9.16667H0.333496V12.8333H22.6452Z"
        fill="#4d4d4c"
      />
    </svg>
  );
};

export default ArrowRightBigIcon;
